import { Component } from "react"
import PropTypes from "prop-types"

export default class NewOrgForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      formDisabled: true,
    }
  }

  handleNameChange = e => {
    this.setState({
      formDisabled: e.target.value.length == 0,
    })
  }

  submitNewOrgForm = () => {
    this.newOrgForm.submit()
    this.setState({
      formDisabled: true,
    })
  }

  render() {
    return (
      <form
        onSubmit={this.submitNewOrgForm}
        className="new-org-form"
        action={this.props.createOrgUri}
        method="post"
        ref={form => {
          this.newOrgForm = form
        }}
      >
        <h3>New organization name:</h3>
        <input type="text" name="name" onChange={this.handleNameChange} />
        <input
          type="hidden"
          name="authenticity_token"
          value={window.App.authenticityToken}
        />
        <br />
        <br />
        <input
          type="submit"
          value="Save"
          disabled={this.state.formDisabled}
          onClick={this.submitNewOrgForm}
          className="button-primary"
        />
      </form>
    )
  }
}

NewOrgForm.propTypes = {
  createOrgUri: PropTypes.string,
}
